import { IPlugin, PluginStore } from "react-pluggable";
import ProductIngredients from "./components/ProductIngredients/ProductIngredients";

class ProductIngredientsPlugin implements IPlugin {
    pluginStore!: PluginStore;

    init(pluginStore: PluginStore): void {
        this.pluginStore = pluginStore;
    }

    getPluginName(): string {
        return 'ProductIngredients@1.0.0';
    }

    getDependencies(): string[] {
        return [];
    }

    deactivate(): void { }

    activate(): void {
        this.pluginStore.executeFunction('Renderer.add', 'page:ingredients', () => (
            <ProductIngredients></ProductIngredients>
        ));
    }
}

export default ProductIngredientsPlugin;